import { Map, List } from "immutable";
import {
    CompanyRecordPipeline,
    AssociatesPipeline,
    AddressesPipeline,
    BankAccountsPipeline
} from "utilities/data-pipelines";
import { CompanyRecord, BankAccountRecord } from "records/company-record";
import { COMPANY_ACTIONS, STATE_STATUS } from "constants";
import { CaseNoteRecord, OnboardingCasesRecord } from "../../records";
import moment from "moment";
import _groupBy from "lodash/groupBy";

const INITIAL_STATE = new Map({
    notes : {
        data : Map({}),
        status : STATE_STATUS.UNFETCHED 
    },
    createNoteStatus : STATE_STATUS.UNFETCHED,
    checklist : {
        data : Map({}),
        status : STATE_STATUS.UNFETCHED
    },
    associatesListV2 : Map({}),
    associatesListV2Status: STATE_STATUS.UNFETCHED,
    mpaStatus : STATE_STATUS.UNFETCHED,
    allMpaDetails : Map({
        status : STATE_STATUS.UNFETCHED,
        data : List()
    }),
    enums: Map({
        status : STATE_STATUS.UNFETCHED,
        data : Map()
    })
});

export default (state = INITIAL_STATE, { type, payload, error }) => {
    switch (type) {
    case COMPANY_ACTIONS.FETCH_COMPANY_PROFILE:
        return state.set(
            payload.companyId,
            new Map({
                status: new Map({
                    companyStatus: STATE_STATUS.FETCHING,
                    associatesStatus: STATE_STATUS.FETCHING,
                    addressesStatus: STATE_STATUS.FETCHING,
                    bankAccountsStatus: STATE_STATUS.FETCHING,
                    cibilStatus: STATE_STATUS.FETCHING
                }),
                data: new CompanyRecord(),
                error: null
            })
        );
    case COMPANY_ACTIONS.FETCHED_COMPANY_PROFILE:
        return state
            .setIn(
                [payload.companyId, "status"],
                state
                    .getIn([payload.companyId, "status"])
                    .map(() => STATE_STATUS.FETCHED)
            )
            .setIn(
                [payload.companyId, "data"],
                CompanyRecordPipeline.run(payload.profile)
            );
    case COMPANY_ACTIONS.FAILED_FETCH_COMPANY_PROFILE:
        return state
            .setIn(
                [payload.companyId, "status", "companyStatus"],
                STATE_STATUS.FETCH_FAILED
            )
            .setIn([payload.companyId, "error"], error);
    case COMPANY_ACTIONS.UPDATE_COMPANY_PROFILE:
        return state
            .setIn(
                [payload.companyId, "status", "companyStatus"],
                STATE_STATUS.UPDATING
            )
            .setIn(
                [payload.companyId, "data"],
                CompanyRecordPipeline.run(payload.profile)
            );
    case COMPANY_ACTIONS.UPDATED_COMPANY_PROFILE:
        return state
            .setIn(
                [payload.companyId, "status", "companyStatus"],
                STATE_STATUS.UPDATED
            )
            .setIn(
                [payload.companyId, "data"],
                CompanyRecordPipeline.run(payload.profile)
            );
    case COMPANY_ACTIONS.FAILED_UPDATE_COMPANY_PROFILE:
        return state
            .setIn(
                [payload.companyId, "status", "companyStatus"],
                STATE_STATUS.UPDATE_FAILED
            )
            .setIn([payload.companyId, "error"], error);
    case COMPANY_ACTIONS.UPDATE_COMPANY_ASSOCIATES:
        return state.setIn(
            [payload.companyId, "status", "associatesStatus"],
            STATE_STATUS.UPDATING
        );
        // .setIn(
        //     [payload.companyId, "data", "associates"],
        //     new List(payload.associates).toMap().mapEntries(([, v]) => [v.id, ])
        // );
    case COMPANY_ACTIONS.UPDATED_COMPANY_ASSOCIATES:
        return state
            .setIn(
                [payload.companyId, "status", "associatesStatus"],
                STATE_STATUS.UPDATED
            )
            .mergeIn(
                [payload.companyId, "data", "associates"],
                AssociatesPipeline.run(new List(payload.associates))
            );
    case COMPANY_ACTIONS.UPDATE_COMPANY_ASSOCIATES_CIBIL:
        return state.setIn([payload.companyId, "cibilStatus"], STATE_STATUS.UPDATING);

    case COMPANY_ACTIONS.UPDATED_COMPANY_ASSOCIATES_CIBIL:
        return state.setIn([payload.companyId, "cibilStatus"], STATE_STATUS.UPDATED);
    case COMPANY_ACTIONS.FAILED_UPDATE_COMPANY_ASSOCIATES_CIBIL:
        return state.setIn([payload.companyId, "cibilStatus"], STATE_STATUS.UPDATE_FAILED);

    case COMPANY_ACTIONS.FAILED_UPDATE_COMPANY_ASSOCIATES:
        return state
            .setIn(
                [payload.companyId, "status", "associatesStatus"],
                STATE_STATUS.UPDATE_FAILED
            )
            .setIn([payload.companyId, "error"], error);
    case COMPANY_ACTIONS.UPDATE_COMPANY_ADDRESSES:
        return state.setIn(
            [payload.companyId, "status", "addressesStatus"],
            STATE_STATUS.UPDATING
        );
    case COMPANY_ACTIONS.UPDATED_COMPANY_ADDRESSES:
        return state
            .setIn(
                [payload.companyId, "status", "addressesStatus"],
                STATE_STATUS.UPDATED
            )
            .mergeIn(
                [payload.companyId, "data", "addresses"],
                AddressesPipeline.run(new List(payload.addresses))
            );

    case COMPANY_ACTIONS.FAILED_UPDATE_COMPANY_ADDRESSES:
        return state
            .setIn(
                [payload.companyId, "status", "addressesStatus"],
                STATE_STATUS.UPDATE_FAILED
            )
            .setIn([payload.companyId, "error"], error);
    case COMPANY_ACTIONS.UPDATE_COMPANY_BANK_ACCOUNTS:
        return state.setIn(
            [payload.companyId, "status", "bankAccountsStatus"],
            STATE_STATUS.UPDATING
        );
        // .setIn(
        //     [payload.companyId, "data", "bankAccounts"],
        //     new List(payload.bankAccounts)
        // );
    case COMPANY_ACTIONS.UPDATED_COMPANY_BANK_ACCOUNTS:
        return state
            .setIn(
                [payload.companyId, "status", "bankAccountsStatus"],
                STATE_STATUS.UPDATED
            )
            .mergeIn(
                [payload.companyId, "data", "bank_accounts"],
                BankAccountsPipeline.run(new List(payload.bankAccounts))
            );

    case COMPANY_ACTIONS.FAILED_UPDATE_COMPANY_BANK_ACCOUNTS:
        return state
            .setIn(
                [payload.companyId, "status", "bankAccountsStatus"],
                STATE_STATUS.UPDATE_FAILED
            )
            .setIn([payload.companyId, "error"], error);
    case COMPANY_ACTIONS.UPDATED_COMPANY_SINGLE_BANK_ACCOUNT:
        return state
            .setIn(
                [payload.companyId, "data", "bank_accounts", payload.bankAccount && payload.bankAccount.id],
                new BankAccountRecord(payload.bankAccount)
            );
    case COMPANY_ACTIONS.UPDATE_COMPANY_ADDRESS:
        return state.setIn(
            [payload.companyId, "status", "addressesStatus"],
            STATE_STATUS.UPDATING
        );
    case COMPANY_ACTIONS.UPDATED_COMPANY_ADDRESS:
        return state
            .setIn(
                [payload.companyId, "status", "addressesStatus"],
                STATE_STATUS.UPDATED
            )
            .mergeIn(
                [payload.companyId, "data", "addresses"],
                AddressesPipeline.run(new List([payload.address]))
            );

    case COMPANY_ACTIONS.FAILED_UPDATE_COMPANY_ADDRESS:
        return state
            .setIn(
                [payload.companyId, "status", "addressesStatus"],
                STATE_STATUS.UPDATE_FAILED
            )
            .setIn([payload.companyId, "error"], error);

    case COMPANY_ACTIONS.FETCH_COMPANY_CHECKLIST:
        return state.setIn(
            ['checklist' , 'status'],
            STATE_STATUS.FETCHING
        );
    case COMPANY_ACTIONS.FETCHED_COMPANY_CHECKLIST:
        return state
            .setIn(
                ['checklist' , 'status'],
                STATE_STATUS.FETCHED
            )
            .setIn(['checklist' , 'data'] , Map(payload.data))

    case COMPANY_ACTIONS.FAILED_FETCH_COMPANY_CHECKLIST:
        return state
            .setIn(
                ['checklist' , 'status'],
                STATE_STATUS.FETCH_FAILED
            )

    case COMPANY_ACTIONS.FETCH_COMPANY_NOTES:
        return state.setIn(
            ['notes' , 'status'],
            STATE_STATUS.FETCHING
        );
    case COMPANY_ACTIONS.FETCHED_COMPANY_NOTES:
        let notes = payload.data.map(
            _ =>
                new CaseNoteRecord({
                    ..._,
                    create_date: moment(_.create_date),
                    create_date_string: moment(_.create_date).format("DD-MM-YYYY"),
                    state_status: STATE_STATUS.CREATED
                })
        );
        return state
            .setIn(
                ['notes' , 'status'],
                STATE_STATUS.FETCHED
            )
            .setIn(['notes' , 'data'] , new Map(_groupBy(notes, "create_date_string")).toOrderedMap().sort((a, b) => {
                if(a[0].id > b[0].id) {
                    return -1;
                }
                if(a[0].id > b[0].id) {
                    return 1;
                }
                if(a[0].id === b[0].id) {
                    return 0;
                }
            }))

    case COMPANY_ACTIONS.FAILED_FETCH_COMPANY_NOTES:
        return state
            .setIn(
                ['notes' , 'status'],
                STATE_STATUS.FETCH_FAILED
            )


    case COMPANY_ACTIONS.CREATE_COMPANY_NOTE:
        return state.set(
            'createNoteStatus',
            STATE_STATUS.FETCHING
        );
    case COMPANY_ACTIONS.FETCHED_CREATE_COMPANY_NOTE:
        
        return state
            .set(
                'createNoteStatus',
                STATE_STATUS.FETCHED
            )

    case COMPANY_ACTIONS.FAILED_CREATE_COMPANY_NOTE:
        return state
            .set(
                'createNoteStatus',
                STATE_STATUS.FETCH_FAILED
            )


    
    case COMPANY_ACTIONS.FETCH_COMPANY_ASSOCIATES_V2:
        return state.set(
            'associatesListV2Status',
            STATE_STATUS.FETCHING
        );
    case COMPANY_ACTIONS.FETCHED_COMPANY_ASSOCIATES_V2:
        var data = Map();        
        payload.data.map(_ => {
           data =  data.set(_.id , _)
        })
        return state
            .set(
                'associatesListV2Status',
                STATE_STATUS.FETCHED
            )
            .set(
                'associatesListV2',
                data
            )

    case COMPANY_ACTIONS.FAILED_FETCH_COMPANY_ASSOCIATES_V2:
        return state
            .set(
                'associatesListV2Status',
                STATE_STATUS.FETCH_FAILED
            )

    case COMPANY_ACTIONS.UPDATE_MPA_DETAILS:
        return state.set('mpaStatus', STATE_STATUS.FETCHING);

    case COMPANY_ACTIONS.UPDATED_MPA_DETAILS:
        return state.set('mpaStatus', STATE_STATUS.FETCHED)
            .setIn(['mpaLoader', 'loaderFor'] , payload.loaderFor)
            .setIn(['allMpaDetails' , 'data'], List())

    case COMPANY_ACTIONS.FAILED_UPDATE_MPA_DETAILS:
        return state.set('mpaStatus',STATE_STATUS.FETCH_FAILED)


    case COMPANY_ACTIONS.CLEAR_COMPANY_ALL_MPA:
        return state.setIn(['allMpaDetails' , 'status'], STATE_STATUS.UNFETCHED)
                .setIn(['allMpaDetails' , 'data'], List())


    case COMPANY_ACTIONS.FETCH_COMPANY_ALL_MPA:
        return state.setIn(['allMpaDetails' , 'status'], STATE_STATUS.FETCHING);

    case COMPANY_ACTIONS.FETCHED_COMPANY_ALL_MPA:
        return state
            .setIn(['allMpaDetails' , 'status'], STATE_STATUS.FETCHED)
            .setIn(['allMpaDetails' , 'data'] , payload.data.results.map(_ => new OnboardingCasesRecord({mpa_approval: _})))

    case COMPANY_ACTIONS.FAILED_FETCH_COMPANY_ALL_MPA:
        return state.setIn(['allMpaDetails' , 'status'], STATE_STATUS.FETCH_FAILED)

    case COMPANY_ACTIONS.FETCH_ENUMS:
        return state.setIn(['enums' , 'status'], STATE_STATUS.FETCHING);

    case COMPANY_ACTIONS.FETCHED_ENUMS:
        const transformedData = Object.keys(payload.data).reduce((acc, key) => {
            acc[key] = Object.entries(payload.data[key]).map(([innerKey, innerValue]) => ({
                label: innerValue,
                value: parseInt(innerKey, 10)
            }));
            return acc;
        }, {})
        return state
            .setIn(['enums' , 'status'], STATE_STATUS.FETCHED)
            .setIn(['enums' , 'data'] , transformedData)

            

    case COMPANY_ACTIONS.FAILED_FETCH_ENUMS:
        return state.setIn(['enums' , 'status'], STATE_STATUS.FETCH_FAILED)
        

        enums
    case "LOGOUT":
        return INITIAL_STATE;
    default:
        return state;
    }
};
